document.addEventListener("DOMContentLoaded", function () {
  const cart = document.querySelector(".fixed_cart");
  const detail = document.querySelector(".fixed_cart_detail");
  const closeBtn = document.querySelector(".close_icon");

  cart.addEventListener("click", function () {
    detail.classList.add("fixed_cart_detail_show");
  });

  closeBtn.addEventListener("click", function () {
    detail.classList.remove("fixed_cart_detail_show");
  });

  // 外側クリックで閉じる
  document.addEventListener("click", function (e) {
    if (
      detail.classList.contains("fixed_cart_detail_show") && // 開いてる時
      !detail.contains(e.target) && // 中身をクリックしてない
      !cart.contains(e.target) // トリガーボタンをクリックしてない
    ) {
      detail.classList.remove("fixed_cart_detail_show");
    }
  });
});